import { FEATURES } from '@constants/Text'
import { registrar } from '@modules/aawz-intelligence-v2/ui-registry'
import registryComissoes from './ia/registry'
import * as comissoesStore from './store'
import * as comissoesIaStore from './store/ia'

export function comissoesModule({ store }) {
  // ⚠️ Guarda de REENTRADA (padrão de `modules/consolidator/index.js`). Sem o
  // `registrar` abaixo ela não doía — `registerModule` chamado duas vezes só
  // sobrescrevia o store em silêncio. Com ele passa a ser necessária: o
  // `registrar` RECUSA chave repetida por desenho (override silencioso entre
  // módulos é bug), e uma segunda chamada faria o boot ESTOURAR.
  if (typeof store.hasModule === 'function' && store.hasModule('comissoes')) {
    return
  }

  store.registerModule('comissoes', { ...comissoesStore, namespaced: true })
  // Chat do Especialista em Comissionamento (aba de IA). Namespace separado do
  // `aawz-intelligence-v2` para não misturar conversa nem persona.
  store.registerModule('comissoesIa', { ...comissoesIaStore, namespaced: true })

  // O cartão do módulo dentro da conversa: o MÓDULO se registra e o agregado
  // só consulta — é o que permite o `chat-message.vue` desenhar o relatório de
  // comissionamento sem importar nada daqui.
  //
  // Aqui, e não numa view: o cartão pode chegar em QUALQUER conversa (a aba de
  // IA deste módulo e o chat da plataforma compartilham o `UI_REGISTRY`), e
  // registrar na view deixaria o mesmo `tool_result` virar cartão numa tela e
  // `fallback-card` na outra. `registerAllModules` roda uma vez, no boot.
  registrar(registryComissoes)
}

export const PERMISSION = FEATURES.COMISSOES
export const PERMISSION_MANAGER = FEATURES.COMISSOES_MANAGER
